<!-- 中奖查询 -->
<template>
  <div class="win_content">
    <div class="w_title">
      <jd-button type="blue"
        :styleTextObj="{ width: '44px', height: '24px', 'line-height': '24px', padding: '0 8px', 'min-width': '44px' }"
        @click="toSetting()">返回</jd-button>
      <div class="title_text">中奖查询</div>
    </div>
    <!-- 查询区 -->
    <div class="w_search">
      <jd-form :formInfo="inputAwardTwo" ref="export_fun33" @search="searchAwardOne"></jd-form>
    </div>
    <!-- 表格 -->
    <div class="w_table">
      <!-- 表格 -->
      <jd-table :loading="loading" :tableData="getRecordList" style="width: 100%;"
        :pageInfo="{
          pageNum: current,
          pageSize: size,
          noShow: false,
          total: totalRecord,
        }"
        @handlePage="handlePages"
      >
        <el-table-column prop="pin" label="用户pin（加密）" width="150">
        </el-table-column>
        <el-table-column prop="memberNick" label="用户昵称">
        </el-table-column>
        <el-table-column prop="activityName" label="活动名称">
        </el-table-column>
        <el-table-column prop="activitySubType" label="活动类型">
          <template slot-scope="scope">
            <span>{{ getActivityType(scope.row.activitySubType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="prizeType" label="奖品类型">
          <template slot-scope="scope">
            <span>{{ getPrizeType(scope.row.prizeType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="prizeName" label="奖品名称">
          <template slot-scope="scope">
            <span v-if="scope.row.prizeName"> {{ scope.row.prizeName }} </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column prop="joinTime" label="参与时间">
          <template slot-scope="scope">
            <span v-if="scope.row.joinTime">{{ scope.row.joinTime }} </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column prop="winTime" label="领奖时间">
          <template slot-scope="scope">
            <span v-if="scope.row.winTime">{{ scope.row.winTime }} </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column prop="grantTime" label="发放时间">
          <template slot-scope="scope">
            <span v-if="scope.row.grantTime">{{ scope.row.grantTime }} </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="中奖状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == -1">待领取</span>
            <span v-if="scope.row.status == 1">未中奖</span>
            <span v-if="scope.row.status == 2">已中奖</span>
            <span v-if="scope.row.status == 3 || scope.row.status == 5 || scope.row.status == 6">已发放</span>
            <span v-if="scope.row.status == 4">发放失败</span>
            <span v-if="scope.row.status == 7">待发放</span>
            <span v-if="scope.row.status == 8">已失效</span>
            <el-tooltip class="item" effect="light"
              v-if="scope.row.failReason && scope.row.status == 4 || scope.row.failReason && scope.row.status == 8"
              :content="scope.row.failReason" placement="bottom">
              <el-button type="text" style="width: 35px;">
                <i class="el-icon-question" style="color: #ccc;"></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </jd-table>
    </div>
  </div>
</template>

<script>
import statisticsData from "@/mixin/activity_statistics_new_atwo.js";
import inputForm from "@/components/jhk/inputForm";
import { getWinRecordByPin } from "@/api/jhk/paradiseAndTaskCommonController.js";
export default {
  mixins: [statisticsData],
  components: {
    inputForm
  },
  data() {
    return {
      loading: false,
      inputAwardTwo: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "中奖状态：",
          prop: "status",
          placeholder: "请选择",
          value: "",
          type: "Select",
          options: [
            { label: "全部", value: "" },
            { label: "未中奖", value: "1" },
            { label: "待领取", value: "-1" },
            { label: "已中奖", value: "2" },
            { label: "待发放", value: "7" },
            { label: "已发放", value: "3,5,6" },
            { label: "已失效", value: "8" },
            { label: "发放失败", value: "4" },
          ],
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "优惠券", value: "1" },
            { label: "京豆", value: "2" },
            { label: "实物", value: "3" },
            { label: "店铺积分", value: "4" },
            { label: "京东E卡", value: "5" },
            { label: "爱奇艺会员", value: "6" },
            { label: "PLUS会员", value: "7" },
            { label: "现金红包", value: "8" },
            { label: "礼品卡", value: "10" },
          ],
        },
        {
          label: "参与时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "joinTimeStart",
          endKey: "joinTimeEnd",
          startTime: "",
          endTime: ""
        },
        {
          label: "领奖时间：",
          type: "DateRange",
          dateType: "datetime",
          val: ["winTimeStart", "winTimeEnd"],
          startKey: "winTimeStart",
          endKey: "winTimeEnd",
          startTime: "",
          endTime: ""
        },
        {
          label: "发放时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "grantTimeStart",
          endKey: "grantTimeEnd",
          startTime: "",
          endTime: ""
        }
      ],
      getRecordList: [],
      formListRecord: {
        pin: "",
        memberNick: "",
        status: "",
        prizeType: "",
        joinTimeStart: '',
        joinTimeEnd: '',
        winTimeStart: '',
        winTimeEnd: '',
        grantTimeStart: '',
        grantTimeEnd: '',
      },
      current: 1,
      size: 10,
      totalRecord: 0
    }
  },
  methods: {
    getInfo() {
      let params = { ...this.formListRecord, size: this.size, current: this.current }
      console.log("params>>>", params);
      // 用户 pin或 昵称至少输入一个
      if (!params.pin && !params.memberNick) {
        this.$message({ type: 'warning', message: '请输入用户PIN或用户昵称进行查询' })
        return
      }
      this.loading = true
      getWinRecordByPin(params).then(res => {
        this.loading = false
        console.log("------getWinRecordByPin----res", res)
        if (res.code == 200 || res.code == 1) {
          this.getRecordList = res.data.records.map(item => {
            return { ...item, pin: item.pin[0] + "*" + item.pin[item.pin.length - 1] }
          })
          this.totalRecord = Number(res.data.total)
        }
      }).catch(err => {
        this.loading = false
      })
    },
    // 查询按钮点击事件
    searchAwardOne(val) {
      this.size = 10
      this.current = 1
      this.totalRecord = 0
      const { pin, memberNick, status, prizeType, joinTimeStart, joinTimeEnd, winTimeStart, winTimeEnd, grantTimeStart, grantTimeEnd } = val
      this.formListRecord = { pin, memberNick, status, prizeType, joinTimeStart, joinTimeEnd, winTimeStart, winTimeEnd, grantTimeStart, grantTimeEnd };
      this.getRecordList = []
      this.getInfo()
    },
    handlePages(page) {
      this.current = page.pageNum;
      this.size = page.pageSize;
      this.getInfo();
    },
    // 返回按钮等点击事件
    toSetting() {
      // 返回后刷新 this.$emit("returnBack",true);
      this.$emit("returnBack", true);
    },
    getPrizeType(type) {
      const prizeTypes = {
        1: "优惠券",
        2: "京豆",
        3: "实物",
        4: "店铺积分",
        5: "京东E卡",
        6: "爱奇艺会员",
        7: "京豆PLUS会员",
        8: "现金红包",
        10: "礼品卡",
        12: "专享价",
        13: "令牌"
      };
      return prizeTypes[type] || "-";
    },
    getActivityType(type) {
      let activityTypes = {
        1: "日历签到",
        2: "浏览礼品有礼",
        3: "每日限时抢",
        4: "关注店铺有礼",
        5: "邀请开卡有礼",
        6: "邀请关注有礼",
        7: "完善信息有礼",
        8: "大转盘抽奖",
        9: "积分兑换实物",
        10: "积分兑换优惠券",
        11: "新人优惠券",
        12: "会员优惠券",
        13: "开卡礼包",
        14: "店铺礼包",
        15: "店铺礼包（千人千面）",
        16: "下单有礼",
        17: "首单专享礼",
        18: "复购有礼",
        19: "下单抽奖",
        20: "评价有礼",
        21: "裂变神券",
        22: "天降红包雨",
        23: "欢乐娃娃机",
        24: "大家来找茬",
        25: "智能活动海报",
        26: "刮刮乐",
        27: "预售有礼",
        28: "预售抽奖",
        29: "积分兑换京豆",
        30: "积分兑换E卡",
        31: "超级裂变券",
        32: "会员卡片",
        33: "0元试用",
        34: "加购有礼",
        35: "积分确权活动",
        36: "打榜有礼",
        37: "派样回购礼",
        38: "积分兑换红包",
        39: "生日有礼",
        40: "专属赠品礼",
        41: "晒单有礼",
        42: "派样回购礼（随单发）",
        43: "N元锁权",
        44: "会员升级礼",
        45: "锁权有礼",
        46: "满额有礼",
        47: "调查问卷",
        48: "定时开奖",
        50: "情书贺卡",
        51: "0元试用",
        52: "试用回购礼",
        53: "购物打卡",
        62: "集卡有礼",
        63: "BI店铺礼包",
        64: "组队瓜分奖品",
        65: "粉丝打卡",
        66: "入会有礼",
        67: "销售打榜",
        68: "会员成长计划",
        69: "拼团砍价",
        70: "积分竞拍",
        71: "趣味游戏",
        74: "关注礼包",
        75: "加购礼包",
        76: "时光许愿池",
        77: "购物车锦鲤",
        78: "打包一口价",
        79: "盖楼有礼",
        80: "小红书晒单礼",
        81: "集分冲榜",
        82: "粉丝集分应援",
        83: "晒图pk",
        84: "日历打卡",
        85: "百变趣答",
        86: "AI趣味答题",
        87: "答题导购",
        89: "积分兑换优惠券",
      };
      return activityTypes[type] || "-";
    },
  }
}
</script>

<style lang="scss" scoped>
.win_content {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;
  border-radius: 8px;
  background-color: white;

  .w_title {
    display: flex;
    align-items: center;
    height: 50px;
    margin-left: 8px;

    .title_text {
      font-size: 18px;
      font-weight: 600;
      margin-left: 10px;
    }
  }

  .w_search {
    width: 100%;
    margin-top: 30px;
  }

  .w_table {
    margin-top: 40px;
    border: 1px solid #F2F2F2;
  }

}
</style>